import React from 'react';
import { IconProps } from '.';

type LocationsIconProps = {
  color?: string;
} & IconProps;

export const LocationsIcon: React.FC<LocationsIconProps> = ({
  width = 24,
  height = 24,
  color = '#222427',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 25 24"
    >
      <path
        fill={color}
        d="M14.512 8.657a10.84 10.84 0 01-.25 2.245c.213.45.438.898.675 1.335.321-1.09.494-2.22.513-3.355a7.998 7.998 0 00-1.713-4.915 4.37 4.37 0 00-.4.848 6.876 6.876 0 011.175 3.842z"
      ></path>
      <path
        fill={color}
        d="M7.75 23.052C5.8 20.495.925 13.597.925 8.657a6.804 6.804 0 011.986-4.815 6.832 6.832 0 014.814-2.008 6.724 6.724 0 015.15 2.432c.13-.282.277-.557.438-.823A7.575 7.575 0 007.725.948 7.845 7.845 0 002.22 3.314 7.813 7.813 0 000 8.869c0 6.1 6.738 14.432 7.013 14.782a.9.9 0 001.073.257.863.863 0 00.302-.232 35.972 35.972 0 006.25-10.491c-.225-.387-.45-.786-.663-1.247A35.956 35.956 0 017.75 23.052z"
      ></path>
      <path
        fill={color}
        d="M7.675 11.127a2.68 2.68 0 01-2.428-1.693 2.664 2.664 0 01.625-2.89 2.677 2.677 0 014.33 2.96 2.655 2.655 0 01-1.485 1.443c-.332.129-.686.19-1.042.18zm0-4.279A1.627 1.627 0 006.174 7.85a1.619 1.619 0 001.184 2.211 1.629 1.629 0 001.668-.69 1.62 1.62 0 00-1.351-2.522zM19.163 0a5.797 5.797 0 00-4.8 2.62c.162.174.3.361.45.548a4.994 4.994 0 014.35-2.494 5.143 5.143 0 013.616 1.51A5.121 5.121 0 0124.275 5.8c0 4.03-3.625 8.97-5.087 10.815a39.988 39.988 0 01-3.113-4.752c-.1.337-.2.673-.312.998a35.02 35.02 0 002.875 4.203.699.699 0 00.525.262.713.713 0 00.525-.237c.212-.25 5.287-6.137 5.287-11.126a5.881 5.881 0 00-1.67-4.181A5.906 5.906 0 0019.163 0zM14.263 10.902a11.5 11.5 0 01-.275 1.086c.212.424.437.823.662 1.247.1-.324.2-.636.288-.96-.238-.475-.463-.924-.675-1.373zM13.338 4.815a4.37 4.37 0 01.4-.848 5.553 5.553 0 00-.425-.524c-.161.266-.307.541-.438.823.162.187.325.362.463.549z"
      ></path>
      <path
        fill={color}
        d="M19.163 7.771a2.14 2.14 0 01-1.976-1.32 2.129 2.129 0 01.469-2.325A2.139 2.139 0 0121.3 5.65a2.13 2.13 0 01-.63 1.5c-.4.397-.942.62-1.507.62zm0-3.205a1.089 1.089 0 00-1.067 1.297 1.084 1.084 0 00.855.852 1.09 1.09 0 001.3-1.064 1.084 1.084 0 00-1.088-1.085z"
      ></path>
    </svg>
  );
};
